import axios from "axios";
import BASE_URL from "../../../../../assets/global/url";
import { fetchPagedWithDetails } from "../../../../../utils/export/batchFetch";
import { renderPdfInWorker } from "../../../../../utils/export/pdfWorker";
import PayablePdf from "./PayablePdf";
import exportPayableExcel from "./payableExcel";

// Export config for ExportOptionsModal (see components/Export).

const PAGE_SIZE = 200;

// Same status grouping the tabs use. `value` is what /fetchPayableSs takes;
// it expands "Approved" to the statuses in `includes` itself.
const STATUSES = [
  { value: "Pending", label: "Pending", includes: ["Pending"] },
  {
    value: "Approved",
    label: "Approved",
    includes: ["Approved", "Partially-Paid", "Paid"],
  },
];

function toExportPayable(row, detail) {
  return {
    id: row.id,
    client_transaction_id: row.client_transaction_id,
    purchaseDate: row.purchaseDate,
    dueDate: row.due_date,
    warehouse: row.warehouse,
    vendor: row.vendor,
    domestic_type: row.domestic_type,
    totalPrice: row.totalPrice,
    currency_name: row.currency?.currency_name || row.currency_name || "PHP",
    items: (detail?.items || []).map((item) => ({
      ...item,
      // not stored; calculated as net_weight × unitPrice
      totalPrice:
        (parseFloat(item.net_weight) || 0) * (parseFloat(item.unitPrice) || 0),
    })),
  };
}

async function fetchRecords({
  status,
  startDate,
  endDate,
  filters,
  signal,
  onProgress,
}) {
  const { rows, details } = await fetchPagedWithDetails({
    recordLabel: "payables",
    signal,
    onProgress,
    fetchPage: async (page) => {
      const res = await axios.get(`${BASE_URL}/payable/fetchPayableSs`, {
        params: {
          startDate,
          endDate,
          status,
          currencyId: filters?.currencyId,
          limit: PAGE_SIZE,
          page,
          // Stable key so rows can't shift between pages mid-export
          sortBy: "id",
          sortDirection: "ASC",
        },
        signal,
      });
      return { rows: res.data.data || [], totalPages: res.data.totalPages };
    },
    fetchDetails: async (batch) => {
      const res = await axios.post(
        `${BASE_URL}/payable/getPayableExportDetails`,
        { ids: batch.map((row) => row.id).filter(Boolean) },
        { signal },
      );
      return res.data || {};
    },
  });

  // Fetched by id for stable paging; present them latest purchase date first
  rows.sort((a, b) =>
    String(b.purchaseDate || "").localeCompare(String(a.purchaseDate || "")),
  );
  return rows.map((row) => toExportPayable(row, details[row.id]));
}

const payableExportConfig = {
  title: "Payable",
  recordLabel: "payables",
  statuses: STATUSES,
  fetchRecords,
  renderPdf: ({ records, meta, signal }) =>
    renderPdfInWorker({
      createWorker: () =>
        new Worker(new URL("./payablePdf.worker.jsx", import.meta.url)),
      Document: PayablePdf,
      props: { records, meta },
      signal,
    }),
  exportExcel: exportPayableExcel,
};

export default payableExportConfig;
